<template>
  <div class="bg">
    <div class="title-container">
      <div class="title">
       <!-- <img src="../../assets/hotKen/icon.png"  /> -->
       科技热点分析2
      </div>
       <div class="title_icon" >
          <img src="../../assets/hotKen/logoing.png" alt="">
      </div>
    </div>
    <div class="main">
      <div class="info">
        <div class="hotspot-title">{{ this.photo_name }}</div>
        <div class="brief-introduction">{{ this.photo_info }}</div>
      </div>
      <div class="main_chart">
        <div class="left">
          <div class="left-top">
            <span class="left-top-title">参与用户画像</span>
            <div class="echart">
              <div class="echart1">
                <div class="p1">性别分布</div>
                <my-pieTwo :sex='sex'></my-pieTwo>
              </div>
              <div class="echart2">
                <div class="p2">年龄分布</div>
                <my-pieThree :age="age"></my-pieThree>
              </div>
            </div>
          </div>
          <div class="left-bottom">
            <span class="left-bottom-title">地域分布</span>
            <div class="map"><nationalMapChart /></div>
            <div class="areas-right">
              <div class="t-head">
                <div class="t1">排行</div>
                <div class="t2">地域</div>
                <div class="t3"></div>
                <div class="t4">热度</div>
              </div>
              <div class="t-body">
                <div
                  class="t-tr"
                  v-for="(item, index) in arr.slice(0, 10)"
                  :key="index"
                >
                  <div class="t1">{{ index + 1 }}</div>
                  <div class="t2">{{ item.name.slice(0, 2) }}</div>
                  <div class="t3">
                    <div
                      :style="((item.percentage / totalSumAll) * 100) | percentage"
                      class="area-range"
                    ></div>
                  </div>
                  <div class="t4">
                    {{ ((item.percentage / totalSumAll) * 100).toFixed(2) }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <span class="right-title">相关新闻</span>
          <div class="header">
            <div class="point">标题</div>
            <div class="comment">来源</div>
          </div>
          <div class="info-body">
            <vue-seamless-scroll
            :data="list_data"
            class="seamless-warp"
            :class-option="defaultOption"
          >
              <div
                class="info-item"
                v-for="(item, index) in list_data"
                :key="index"
                @click="geList(item)"
              >
                <div class="t1">{{ item.title }}</div>
                <div class="t2">{{ item.source }}</div>
              </div>
              </vue-seamless-scroll>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="body_tiele">
        {{ this.list.title }}
        <img
          class="body_img"
          @click="goind(list.url)"
          src="@/assets/lian.png"
          alt=""
        />
      </div>
      <div class="live">
        {{ this.list.source }}
        <div>{{ this.list.newsTime }}</div>
      </div>
      <div class="body_cont">{{ this.list.content }}
         <div class="time_img" >
        <div class="wx_img" v-for="(item,index) in imgs" :key="index">
        <img v-if="item.imgUrl!=''" class="img_wx" :src="item.imgUrl" alt="">
        </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import pieTwo from "../../components/echart/hotspot/pieTwo.vue";
import pieThree from "../../components/echart/hotspot/pieThree.vue";
import nationalMapChart from "@/components/echart/nationalMap/nationalMapChart2";
import myClass from "../../components/echart/hotspot/myClass.vue";
import { getLocalNewsTW,getCrawlNews,userportrait } from "../../api/bot";
var app0;
export default {
    components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      text: "",
      searchRang: "title",
      photo_name: "",
      photo_info: "",
      dialogVisible: false,
      list_data: [],
      list: {},
      area_data: {},
      area_arr: [],
      imgs:[],
      //组件之间
      sex:{},
      age:{},
      classOption: {
        step: 0.5,
        limitMoveNum: 9,
        openTouch: false,
      },
    };
  },
  beforeCreate: function() {
    app0 = this;
  },
  computed: {
      // 监听属性 类似于data概念
    defaultOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },

    //排序
    arr: function() {
      return this.sortKey(this.area_arr, "proportion");
    },
    //热度和
    totalSumAll:function() {
      let totalSumAll = 0;
      this.area_arr.map((item) => {
        totalSumAll += item.percentage;
      });
      return totalSumAll;
    },
  },
  created() {
    this.test();
    this.load();
    this.photo_name = window.localStorage.getItem("photo_name");
    this.photo_info = window.localStorage.getItem("photo_info");
    setInterval(() => {
       this.photo_name = window.localStorage.getItem("photo_name");
    this.photo_info = window.localStorage.getItem("photo_info");
    }, 50);
  },
 watch:{
     photo_name(){
         this.load();
      this.test(); 
     }
 },
  methods: {
    geList(item) {
      this.dialogVisible = true;
      this.list = item;
      var data1=item.images
 var demArray1 =[];
var demArray1 = data1.map(item => {
     return {
        imgUrl: item
        }
      })
      this.imgs=demArray1
      console.log(this.imgs, "获取到的图片");
    },
    handleClose(done) {
      this.dialogVisible = false;
    },
    goind(url) {
      window.open(url);
    },
    test(){
     userportrait({
       text: this.photo_name,
      }).then((res) => {      
        this.sex=res.data.data.sex;
        this.age=res.data.data.age;
     
    })
      },
    sortKey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key];
        var y = b[key];
        return y < x ? -1 : x > y ? 1 : 0; //从小到大排序
      });
    },
    //地域分布接口
    load() {
      getLocalNewsTW({
        text: this.photo_name,
      }).then((res) => {
        this.arr_data = res.data.data.CityTop10[0];
        //对象
        let list = this.arr_data;
        function convertToArray(objct) {
          return Object.keys(objct).map((key) => ({
            name: key,
            percentage: list[key],
          }));
        }
        //数组
        this.area_arr = convertToArray(list);
      });
      //相关新闻接口
      getCrawlNews({
        text: this.photo_name,
        searchRang: this.searchRang,
      }).then((res) => {
        this.list_data = res.data.data;
      });
    },
  },
  filters: {
    percentage(value) {
      if (value) {
        return `width: ${value}%;`;
      }
    },
  },
  components: {
    "my-pieTwo": pieTwo,
    "my-pieThree": pieThree,
    nationalMapChart,
    "my-class": myClass,
  },
};
</script>

<style lang="scss" scoped>
  .title_icon{
    position: absolute;
    right: 5vw;
    top: 4vh;
  }
.time_img{
  width: 100%;
  height: 5vh;
  display: flex;
// justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}
.wx_img{
padding: 10px;
.img_wx{
  width:170px;
  height: 140px;
}
}
.body_tiele {
  font-size: 30px;
  font-family: PingFang;
  font-weight: bold;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
}
.body_img {
  position: relative;
  left: 5px;
  cursor: pointer;
}
.live {
  width: 50%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
  margin: 0 auto;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #60d6dd;
}
.body_cont {
  width: 90%;
  height: 60vh;
  overflow-y: scroll;
  margin: 0 auto;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 28px;
  color: #ffffff;
}
.bg {
  width: 100vw;
  height: 100vh;
  background-image: url("../../assets/hotKen/bgKe.png") ;
  background-size: 100% 100%;
  overflow: hidden;
  .title-container {
    height: 11vh;
    .title {
      color: #fff;
      font-weight: bold;
      font-size: 2vw;
      line-height: 12vh;
      width: 19%;
      margin-left: 2.3%;
      overflow: hidden;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      img {
        vertical-align: middle;
        width: 13%;
        height: 5.2vh;
        margin-right: 3.2%;
      }
    }
  }
  /** 主体部分 **/
  .main {
    height: 85vh;
    width: 90vw;
    margin-left: 5vw;
    .info {
      width: 90vw;
      height: 9vh;
      position: relative;
      top: -1.5vh;
      .hotspot-title {
        text-align: center;
        font-size: 30px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #ffffff;
        line-height: 30px;
             height: 30px;
        overflow:hidden;
	text-overflow:ellipsis;
	white-space:nowrap
      }
      .brief-introduction {
      width: 75%;
    margin: 0 auto;
    text-align: center;
    font-size: 13px;
    font-family: Myriad Pro;
    font-weight: 400;
    color: #cccccc;
    line-height: 16px;
    opacity: 0.7;
    margin-top: 0.5vh;
    height: 33px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
      }
    }
    .main_chart {
      width: 90vw;
      height: 75vh;
      display: flex;
      .left {
        height: 75vh;
        width: 60vw;
        margin-right: 1vw;
        .left-top {
          height: 34vh;
          width: 60vw;
          margin-bottom: 1vh;
          background-image: url("../../assets/Starting/img-hotspot/left_top.png");
          background-size: 100% 100%;
          .left-top-title {
            position: relative;
            width: 119px;
            height: 20px;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 14px;
            left: 2vw;
            top: 2vh;
          }
          .echart {
            width: 60vw;
            height: 28vh;
            display: flex;
            .echart1 {
              width: 20vw;
              height: 25vh;
              margin-top: 5vh;
              margin-left: 6vw;
              .p1 {
                width: 64px;
                height: 16px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #ffffff;
                line-height: 14px;
                opacity: 0.9;
              }
            }
            .echart2 {
              width: 25vw;
              height: 25vh;
              margin-top: 5vh;
              margin-left: 4vw;
              color: white;
              .p2 {
                width: 64px;
                height: 16px;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #ffffff;
                line-height: 16px;
                opacity: 0.9;
              }
            }
          }
        }
        .left-bottom {
          height: 40vh;
          width: 60vw;
          background-image: url("../../assets/Starting/img-hotspot/left_bottom.png");
          background-size: 100% 100%;
          display: flex;
          .left-bottom-title {
            position: relative;
            width: 100px;
            height: 20px;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
            left: 25px;
            top: 1vh;
          }
          .map {
            width: 30vw;
            margin-top: 7vh;
          }
          .areas-right {
            width: 30vw;
            height: 35vh;
            margin-top: 4vh;
            overflow: hidden;
            .t-head,
            .t-body {
              font-size: 0;
              .t1,
              .t2,
              .t3,
              .t4 {
                text-align: center;
                height: 3.72vh;
                line-height: 3.72vh;
                display: inline-block;
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #ffffff;
              }
              .t1 {
                width: 10%;
              }
              .t2 {
                width: 15%;
              }
              .t3 {
                width: 50%;
                text-align: left;
                .area-range {
                  background: orange;
                  border-radius: 16px;
                  height: 12px;
                  display: inline-block;
                }
              }
              .t4 {
                width: 15%;
              }
            }
            .t-body {
              .t1,
              .t2,
              .t3,
              .t4 {
                height: 2.8vh;
                line-height: 2.8vh;
              }
            }
          }
        }
      }
      .right {
        height: 75vh;
        width: 29vw;
        background-image: url("../../assets/Starting/img-hotspot/right.png");
        background-size: 100% 100%;
        .right-title {
          position: relative;
          width: 79px;
          height: 20px;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 20px;
          opacity: 0.9;
          left: 2vw;
          top: 2vh;
        }
        .header {
          width: 29vw;
          height: 2vh;
          position: relative;
          left: 2vw;
          top: 4vh;
          display: flex;
          .point {
            width: 23vw;
            height: 20px;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
          }
          .comment {
            width: 7.5vw;
            height: 20px;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
          }
        }
        .info-body {
          width: 28.5vw;
          height: 57vh;
          margin-top: 60px;
          overflow: hidden;
          .info-item {
            background: rgba(0, 0, 0, 0.2);
            height: 8.5vh;
            line-height: 7vh;
            position: relative;
            margin-bottom: 5px;
            margin-left: 10px;
            display: flex;
            .t1 {
              width: 20vw;
              height: 68px;
              font-size: 24px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #ffffff;
              line-height: 33px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              margin-top: 5px;
              margin-left: 10px;
            }
            .t2 {
              width: 7.5vw;
              height: 68px;
              font-size: 24px;
              line-height: 25px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #ffffff;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              margin-top: 5px;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
